// extracted by mini-css-extract-plugin
module.exports = {"toolbarButton":"styles_toolbarButton__2wFNK","menuIcon":"styles_menuIcon__ohnA9","blue":"styles_blue__1zjos","true":"styles_true__3Qsj5","yellow":"styles_yellow__zL87d"};